import React from 'react';
import { KeyboardDateTimePicker  } from 'mui-rff';

export default function DateTimePickerAdapter(props) {

  return (<KeyboardDateTimePicker
    disableToolbar
    variant='inline'
    ampm={false}
    format="dd.MM.yyyy HH:mm"
    {...props}
  />)

}